import { useNavigate, /* other hooks */ } from 'react-router-dom';

const wrapperRouter = WrappedComponent => props => {
    const navigate = useNavigate();
    // other hooks

    return (
        <WrappedComponent
            {...props}
            {...{ navigate, /* other hooks */ }}
        />
    );
};

export default wrapperRouter;
